import { Configuration, WarehouseApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

// The generated `isJsonMime`, not `() => false`: that override sends an omitted
// optional body as `""`, which the backend's JSON parser rejects (#793).
export const warehouseApi = new WarehouseApi(
  new Configuration({ basePath: axiosBaseUrl }),
  undefined,
  //@ts-ignore
  client,
);
